"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaSizes = exports.CardImage = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../Image/index.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["size", "imageWidth", "imageHeight", "borderRadius", "alt"];
var mediaSizes = exports.mediaSizes = {
  sm: '152px',
  md: '358px'
};

/**
 * CardImage can be used as a component to pass into the media prop on Card.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-card-cardimage--docs) |
 * [Encore site](https://encore.spotify.net/web/components/cards) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/CardImage) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=22202-15755&t=98l5kv0xhhpGkxaj-1)
 */
var CardImage = exports.CardImage = function CardImage(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    imageWidth = _ref.imageWidth,
    imageHeight = _ref.imageHeight,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? (0, _layoutTheme.cssBorderRadius)('base', '4px') : _ref$borderRadius,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (imageWidth || imageHeight) {
    return /*#__PURE__*/_react["default"].createElement(_index.Image, Object.assign({
      alt: alt,
      imageWidth: imageWidth,
      imageHeight: imageHeight,
      borderRadius: borderRadius,
      "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.CardImage
    }, props));
  }
  return /*#__PURE__*/_react["default"].createElement(_index.Image, Object.assign({
    alt: alt,
    style: {
      minInlineSize: mediaSizes[size]
    },
    imageWidth: "100%",
    borderRadius: borderRadius,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.CardImage
  }, props));
};